import React from 'react'
import { Alert } from 'reactstrap'

const AlertNotification = ({ color = 'dark', toggle, message, button = null }) => (
  <Alert className={`alerts__notification${button ? ' alerts__notification--with-button' : ''}`} color={color} toggle={toggle}>
    <div className='alerts__notification_message'>{message}</div>
    {button && (
      <div className='alerts__notification_button'>
        <span role='button' onClick={button.action}>
          {button.text}
        </span>
      </div>
    )}
  </Alert>
)

export default AlertNotification
